import { render, staticRenderFns } from "./UserAgencyEdit.vue?vue&type=template&id=0bcdca88&"
import script from "./UserAgencyEdit.vue?vue&type=script&lang=js&"
export * from "./UserAgencyEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports